import React from 'react';

const ApiKeyPermissionGroupFormModal = React.lazy(() => import('../components/FormModal'));

const apiKeyPermissionGroupModalRegistry = {
    core_apiKeyPermissionGroupId: ApiKeyPermissionGroupFormModal
};

export default apiKeyPermissionGroupModalRegistry;
